import {SERVER_RENDERING_MODE} from '@aboutyou/utils/server-rendering-modes';
import {createContext, useContext} from 'react';

const context = createContext(SERVER_RENDERING_MODE.SSR);

export const ServerRenderingModeProvider = context.Provider;

const useServerRenderingMode = () => useContext(context);

export const useIsBotModeEnabled = () =>
  useServerRenderingMode() === SERVER_RENDERING_MODE.SSR_SEO_BOT;

export const useIsRealUserModeEnabled = () =>
  useServerRenderingMode() === SERVER_RENDERING_MODE.SSR_REAL_USER;

export const useIsClientSideRenderModeEnabled = () =>
  useServerRenderingMode() === SERVER_RENDERING_MODE.CSR;
